import { webhookTypes } from './webhook.types';

export const fetchAllWebhooksStart = () => ({
  type: webhookTypes.FETCH_WEBHOOKS_START,
});

export const setFetchedWebhooks = (webhooks) => ({
  type: webhookTypes.SET_WEBHOOKS,
  payload: webhooks,
});

export const setWebhookStatus = (webhookId, status) => ({
  type: webhookTypes.SET_WEBHOOK_STATUS,
  payload: { webhookId, enabled: status },
});

export const setNewAddedWebhook = (webhookObj) => ({
  type: webhookTypes.SET_NEW_WEBHOOK,
  payload: webhookObj,
});

export const loadingWebhooks = () => ({ type: webhookTypes.LOADING_WEBHOOKS });

export const toggleWebhookEnable = (webhookId, enabled) => ({
  type: webhookTypes.TOGGLE_WEBHOOK_ENABLE,
  payload: { webhookId, enabled },
});

export const setWebhookStatusLoading = (webhookId) => ({
  type: webhookTypes.SET_WEBHOOK_STATUS_LOADING,
  payload: webhookId,
});

export const editWebhookStart = (webhookObj, history) => ({
  type: webhookTypes.EDIT_WEBHOOK_START,
  payload: { webhookObj, history },
});

export const setEditedWebhook = (webhookObj) => ({
  type: webhookTypes.SET_ON_EDIT_WEBHOOK,
  payload: webhookObj,
});

export const addNewWebhook = (webhookObj, history) => {
  return { type: webhookTypes.ADD_WEBHOOK, payload: { webhookObj, history } };
};
